import type { ClientPortfolioBuildingSavingsEditRequestDTO } from "web_myplann/Infrastructure/Api/Api";
import type { BuildingSavingsEditFormOutput } from "web_myplann/Portfolio/Forms/BuildingSavingsForm/buildingSavingsFormSchema";

export const mapBuildingSavingsEditFormToRequest = (
	data: Partial<BuildingSavingsEditFormOutput>,
	{
		payment,
		paymentFrequency,
	}: Pick<BuildingSavingsEditFormOutput, "payment" | "paymentFrequency">,
): Partial<ClientPortfolioBuildingSavingsEditRequestDTO> => {
	const isPaymentChanged = "payment" in data || "paymentFrequency" in data;

	return {
		...data,
		...(isPaymentChanged && { payment, paymentFrequency }),
	};
};
